import axios from "axios"

export async function getEntranceHtmlText(){

    const URL="https://api.marineblue-g.com/v2/group/text/entrance"

    const res= await axios.get(URL)
    .then(r=>{

        return r.data.body 

    })
    .catch(err=>{
        return null
    })

    return res
}

export function parseHtmlAsSingleElement(htmlText) {
  return <div dangerouslySetInnerHTML={{ __html: htmlText }} />;
}

